/**
 * Created by Ivan on 10.08.2026
 */

cleverapps.styles.OfferButtonComponent[Offers.TYPES.STICKERS_PACK] = cleverapps.overrideStyles(cleverapps.styles.OfferButtonComponent, {
    badge: {
        rotation: 30,
        largeFont: true
    },
    position: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -20 }
    }
}, true);
